/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const CalculationParameterKey = {
    SockelbetragEk: 'SockelbetragEK',
    HoechstbetragEk: 'HoechstbetragEK',
    SockelbetragAms: 'SockelbetragAMS',
    Steigerungsbetrag: 'Steigerungsbetrag',
    ProzentU: 'ProzentU',
    ProzentErw: 'ProzentErw'
} as const;
export type CalculationParameterKey = typeof CalculationParameterKey[keyof typeof CalculationParameterKey];


export function instanceOfCalculationParameterKey(value: any): boolean {
    for (const key in CalculationParameterKey) {
        if (Object.prototype.hasOwnProperty.call(CalculationParameterKey, key)) {
            if (CalculationParameterKey[key as keyof typeof CalculationParameterKey] === value) {
                return true;
            }
        }
    }
    return false;
}

export function CalculationParameterKeyFromJSON(json: any): CalculationParameterKey {
    return CalculationParameterKeyFromJSONTyped(json, false);
}

export function CalculationParameterKeyFromJSONTyped(json: any, ignoreDiscriminator: boolean): CalculationParameterKey {
    return json as CalculationParameterKey;
}

export function CalculationParameterKeyToJSON(value?: CalculationParameterKey | null): any {
    return value as any;
}

export function CalculationParameterKeyToJSONTyped(value: any, ignoreDiscriminator: boolean): CalculationParameterKey {
    return value as CalculationParameterKey;
}

